import { PaginationParams, PaginatedQueryParams } from "../types/pagination";

/**
 * Helper function to create unified search API parameters
 */
export const createSearchParams = (
  paginationParams: PaginationParams,
  filters?: Record<string, any>
): PaginatedQueryParams => ({
  pageNumber: paginationParams.pageNumber,
  pageSize: paginationParams.pageSize,
  filters: filters && Object.keys(filters).length > 0 ? filters : undefined,
});

/**
 * Helper function to check if search filters are active
 */
export const hasActiveFilters = (filters?: Record<string, any>): boolean => {
  if (!filters) return false;
  return Object.keys(filters).length > 0 && 
         Object.values(filters).some(value => 
           value !== null && 
           value !== undefined && 
           value !== ''
         );
};

/**
 * Helper function to clear all search filters
 */
export const clearAllFilters = (): Record<string, any> => ({});

/**
 * Helper function to create a single filter
 */
export const createFilter = (field: string, value: any): Record<string, any> => ({
  [field]: value,
});

/**
 * Helper function to merge multiple filters
 */
export const mergeFilters = (...filters: Record<string, any>[]): Record<string, any> => {
  return filters.reduce((acc, filter) => ({ ...acc, ...filter }), {});
};

/**
 * Helper function to remove a specific filter
 */
export const removeFilter = (
  filters: Record<string, any>, 
  field: string
): Record<string, any> => {
  const newFilters = { ...filters };
  delete newFilters[field];
  return newFilters;
};

/**
 * Helper function to update a specific filter
 */
export const updateFilter = (
  filters: Record<string, any>,
  field: string,
  value: any
): Record<string, any> => {
  if (value === null || value === undefined || value === '') {
    return removeFilter(filters, field);
  }
  return { ...filters, [field]: value };
};
